import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import { DatasetAccessStatus } from '~/api/types';
import { Tooltip } from '~/components';
import { AccessAcceptedIcon, AccessRejectedIcon, AccessRequestedIcon } from '~/icons';

const accessIconsConfig = {
  [DatasetAccessStatus.APPROVED]: {
    Icon: AccessAcceptedIcon,
    title: 'access approved',
    color: '#599518',
  },
  [DatasetAccessStatus.PENDING]: {
    Icon: AccessRequestedIcon,
    title: 'access requested',
    color: '#285EFF',
  },
  [DatasetAccessStatus.NO_ACCESS]: {
    Icon: AccessRejectedIcon,
    title: 'no access',
    color: '#ED002A',
  },
};

interface AccessApprovalStatusCellProps {
  accessStatus: DatasetAccessStatus;
  withText?: boolean;
}

const AccessApprovalStatusCell: FC<AccessApprovalStatusCellProps> = ({ accessStatus, withText }) => {
  const { title, Icon, color } = accessIconsConfig[accessStatus];

  return (
    <Tooltip title={withText ? '' : capitalize(title)}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Icon />
        {withText && (
          <Typography variant="bodySmallStrong" sx={{ ml: 1 }} color={color} textTransform="capitalize">
            {title}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default AccessApprovalStatusCell;
